<template>
  <div class="game-thumb-wrap">
    <div
      class="game-thumb-skeleton"
      aria-hidden="true"
      :class="{ 'game-thumb-skeleton--hide': loaded }"
    />
    <img
      :src="displaySrc"
      :alt="alt || 'Game'"
      loading="lazy"
      decoding="async"
      class="game-thumb-img"
      :class="[imgClass, { 'game-thumb-img--show': loaded }]"
      @load="onLoad"
      @error="onError"
    >
  </div>
</template>

<script>
import { GAME_THUMB_PLACEHOLDER } from '@/utils/gameThumbPlaceholder';

export default {
  name: 'GameThumbImg',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    imgClass: { type: String, default: '' },
  },
  data() {
    return {
      displaySrc: '',
      usedFallback: false,
      loaded: false,
    };
  },
  watch: {
    src: {
      immediate: true,
      handler(val) {
        this.usedFallback = false;
        this.loaded = false;
        this.displaySrc = val || GAME_THUMB_PLACEHOLDER;
        this.$nextTick(() => this.checkAlreadyCached());
      },
    },
  },
  methods: {
    checkAlreadyCached() {
      const el = this.$el && this.$el.querySelector && this.$el.querySelector('img');
      if (el && el.complete && el.naturalWidth > 0) {
        this.onLoad();
      }
    },
    onLoad() {
      this.loaded = true;
    },
    onError() {
      if (!this.usedFallback) {
        this.usedFallback = true;
        this.loaded = false;
        this.displaySrc = GAME_THUMB_PLACEHOLDER;
      } else {
        this.loaded = true;
      }
    },
  },
};
</script>

<style scoped>
.game-thumb-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 72px;
  background: #0d0c0a;
  overflow: hidden;
}

.game-thumb-skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    110deg,
    #141210 0%,
    #1f1b18 42%,
    #2c2620 50%,
    #1f1b18 58%,
    #141210 100%
  );
  background-size: 220% 100%;
  animation: game-thumb-shimmer 1.15s ease-in-out infinite;
  transition: opacity 0.28s ease;
  pointer-events: none;
}

.game-thumb-skeleton--hide {
  opacity: 0;
}

.game-thumb-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.game-thumb-img--show {
  opacity: 1;
}

@keyframes game-thumb-shimmer {
  0% {
    background-position: 130% 0;
  }
  100% {
    background-position: -130% 0;
  }
}
</style>
